export const CHARS_IN_SMS = 160;
